var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"err-n"},[_vm._v("400")]),_c('div',{staticClass:"err-msg"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Внимание'))+"!")]),_c('p',[_vm._v(_vm._s(_vm.$t('Неверный запрос'))+"!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }